import { HttpClient } from "@angular/common/http";
import { DataStateChangeEventArgs } from "@syncfusion/ej2-angular-grids";
import { Observable, Subject } from "rxjs";
import { GlobalComponent } from "src/app/global/global.component";
import { GetpayeridBO } from "./employee.model";
import { GeneralService } from 'src/app/service/general.service';
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class GetEmployeeservice extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public global: GlobalComponent, public general: GeneralService) {
    super();
  }
  public executepayerId(state: GetpayeridBO): void {
    this.getListPayerID(state).subscribe(x => super.next(x));
  }

  getListPayerID(state?: GetpayeridBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/PayorRequiredID/GetPayorRequiredIdFilter", state)
      .pipe(map(
        (response: any) => <any>{
          result: response['result'],
          count: response['count']
        }))
  }
}
